export const PUSH_RECENTLY_VIEWED = 'PUSH_RECENTLY_VIEWED';
export const CLEAR_RECENTLY_VIEWED = 'CLEAR_RECENTLY_VIEWED';
